import { Grid, TextField, Typography, useTheme } from '@mui/material';
import { Field } from 'formik';

interface LockerNetworkSettingsProps {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  errors: any;
  touched: any;
}

export function LockerNetworkSettings({
  mode,
  isSubmitting,
  errors,
  touched
}: LockerNetworkSettingsProps) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2} mt={2}>
          Configurações de Rede
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="IP"
          name="ip"
          required
          disabled={isSubmitting || mode === 'edit'}
          error={!!(touched.ip && errors.ip)}
          helperText={mode === 'edit' ? 'IP não pode ser alterado' : (touched.ip && errors.ip)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Porta"
          name="port"
          required
          disabled={isSubmitting || mode === 'edit'}
          error={!!(touched.port && errors.port)}
          helperText={mode === 'edit' ? 'Porta não pode ser alterada' : (touched.port && errors.port)}
        />
      </Grid>
    </>
  );
} 